// /src/components/formbuilder/admin/utils/ExportModal.jsx
import React, { useRef } from 'react';

export default function ExportModal({ show, onClose, jsonData }) {
  const textAreaRef = useRef(null);

  const handleCopy = () => {
    if (textAreaRef.current) {
      textAreaRef.current.select();
      document.execCommand('copy');
    }
  };
  if (!show) return null;
  return (
    <div className="modal fade show d-block" tabIndex="-1" role="dialog">
      <div
        className="modal-backdrop fade show"
        onClick={onClose}
        style={{ cursor: 'pointer' }}
      ></div>
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        role="document"
      >
        <div className="modal-content shadow-lg">
          <div className="modal-header bg-light">
            <div className="modal-title">
              <i className="bi bi-filetype-json me-2"></i> JSON du formulaire
            </div>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <textarea
              ref={textAreaRef}
              readOnly
              className="form-control font-monospace bg-light"
              rows={15}
              value={JSON.stringify(jsonData, null, 2)}
            />
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-outline-secondary"
              onClick={handleCopy}
            >
              <i className="bi bi-clipboard"></i> Copier
            </button>
            <button className="btn btn-primary" onClick={onClose}>
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
